export default __webpack_public_path__ + "static/media/degeneration.c578e50f.jpg";